import { Spacing } from '@persona-id/design-tokens';
import produce from 'immer';
import { startCase } from 'lodash';
import styled from 'styled-components';

import ReactSelect from 'dashboard/components/ReactSelect';
import { VerificationCheckConfiguration } from 'dashboard/forms/FormVerificationTemplateChecks/FormVerificationTemplateChecks';
import { RequiredExtraction } from 'dashboard/models/verification-check';
import { DocumentExtractionCheckConfig } from 'dashboard/models/verification-check-config/document-extracted-properties-detection';
import { VerificationCheckConfig } from 'dashboard/models/verification-check-config/verification-check-config';

const StyledReactSelect = styled(ReactSelect<string[]>).attrs(() => ({ size: 'sm' }))`
  margin-top: ${Spacing[3]};
  margin-bottom: ${Spacing[3]};
`;

interface DocumentExtractedPropertiesConfigurationElementProps {
  checkConfig: DocumentExtractionCheckConfig;
  editable: boolean;
  extractionFieldNames: string[];
  handleUpdateCheck: (check: VerificationCheckConfig) => void;
}

const DocumentExtractedPropertiesConfigurationElement = ({
  checkConfig,
  editable,
  extractionFieldNames,
  handleUpdateCheck,
}: DocumentExtractedPropertiesConfigurationElementProps) => {
  const requiredExtractionsFieldNames =
    checkConfig['required-extractions']?.map(
      (requiredExtraction: RequiredExtraction) => requiredExtraction['field-name'],
    ) || [];
  const updateRequiredExtractions = (updatedRequiredExtractionFieldNames: string[]) => {
    const check = produce(checkConfig, (draft) => {
      draft['required-extractions'] = updatedRequiredExtractionFieldNames.map((fieldName) => {
        return {
          'field-name': fieldName,
          'accept-condition': {
            '!==': [
              {
                var: 'accepts',
              },
              [],
            ] as ([] | { var: string })[],
          },
          name: fieldName,
        };
      });
    });
    handleUpdateCheck(check);
  };
  return (
    <VerificationCheckConfiguration title='Required extractions' disabled={!editable}>
      <StyledReactSelect
        options={extractionFieldNames.map((fieldName) => {
          return {
            label: startCase(fieldName),
            value: fieldName,
          };
        })}
        value={requiredExtractionsFieldNames}
        disabled={!editable}
        onChange={updateRequiredExtractions}
        isMulti
        portal
      />
    </VerificationCheckConfiguration>
  );
};

export default DocumentExtractedPropertiesConfigurationElement;
